import { useSnapshot } from "valtio";
import { onlineStatus } from "src/js/stores/onlineStatus/store";

export function useOnlineStatus() {
  const snap = useSnapshot(onlineStatus);
  return snap.isOnline;
}
